var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._v("\n            bus:\n            "),_c('pre',[_vm._v(_vm._s(_vm.bus))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h1',{staticClass:"card-title"},[_vm._v("Test")])])
}]

export { render, staticRenderFns }